module.exports = __webpack_public_path__ + "img/img_044@2x.7c6cf548.png";